export const generateDynamicQuickApptQuery = ({
  serviceQueryParam,
  categoryQueryParam
}) => {
  if (serviceQueryParam) return `preSelectedService=${serviceQueryParam}`
  if (categoryQueryParam) return `preExpandedService=${categoryQueryParam}`
  return ''
}
